import { AssementSessionData, Examiner, IExaminingTeamMemberWithFunctionId } from '../../models/taskGroup.types';
import { Examiner as ExaminerFromStructure, ExaminersList } from '../ExaminersStructure/ExaminersStructure.types';
import { Examiner as ExaminerFromSolution } from '../../services/examiners/examiners.types';
import { DashboardTile } from '../../pages/Dashboard/Dashboard.types';
import { SelectedExaminer } from '../../services/examiners/examiners.types';
import { SelectedUser } from '../../services/users/users.types';
import { Modal } from '../Modal/Modal.component';
import { NewMessage } from './NewMessage.component';
import { IndexedStrings } from '../SelectableTable/SelectableTable.types';
import { useState } from 'react';
import { Status } from '../../services/exams/assessmentSession/assessments.types';

interface NewMessageDialogProps {
  open: boolean;
  type: 'standard' | 'helpdesk' | 'specialCase' | 'orgzMessage';
  onClose: () => void;
  onSend: () => void;
  recipient?: Examiner | SelectedExaminer[] | SelectedUser[] | ExaminerFromStructure;
  session?: AssementSessionData | DashboardTile | null;
  shouldSessionDataBeHide?: boolean;
  isAllPagesItemChecked?: boolean;
  countOfAllCheckedRecipients?: number;
  recipientWithFunctionId?: ExaminersList;
  recipientWithFunctionIdFromExaminerTreemap?: IExaminingTeamMemberWithFunctionId;
  userFilters?: IndexedStrings;
  rgzId?: string;
  cardId?: string;
  recipientFromOrgz?: ExaminerFromSolution[];
  rgzStatus?: Status | null;
}

export const NewMessageModal: React.FC<NewMessageDialogProps> = (props) => {
  const [cancelConfirmationOpen, setCancelConfirmationOpen] = useState<boolean>(false);

  const notifyMessageModalClosed = () => {
    window.requestAnimationFrame(() => {
      document.dispatchEvent(new Event('assessment:message-modal-closed'));
    });
  };

  const handleClose = () => {
    props.onClose();
    notifyMessageModalClosed();
  };

  const handleSend = () => {
    props.onSend();
    notifyMessageModalClosed();
  };

  const getModalTitle = (type: string) => {
    switch (type) {
      case 'specialCase':
        return 'Szczególny Przypadek';
        break;
      case 'orgzMessage':
        return `RGZ: ${props.rgzId}`;
        break;
      default:
        return '';
    }
  };

  return (
    <Modal
      open={props.open}
      xCloseButton={() => setCancelConfirmationOpen(true)}
      title={`Nowa wiadomość ${getModalTitle(props.type)}`}
      autoHeight
      style={{ maxWidth: '750px', margin: '0 auto' }}
    >
      <div>
        <NewMessage
          onCancel={handleClose}
          onSend={handleSend}
          isModal
          recipient={props.recipient}
          session={props.session}
          shouldSessionDataBeHide={props.shouldSessionDataBeHide}
          isAllPagesItemChecked={props.isAllPagesItemChecked}
          countOfAllCheckedRecipients={props.countOfAllCheckedRecipients}
          messageType={props.type}
          recipientWithFunctionId={props.recipientWithFunctionId}
          recipientWithFunctionIdFromExaminerTreemap={props.recipientWithFunctionIdFromExaminerTreemap}
          userFilters={props.userFilters}
          setCancelConfirmationOpen={cancelConfirmationOpen}
          cancelConfirmationOpen={setCancelConfirmationOpen}
          rgzId={props.rgzId}
          cardId={props.cardId}
          recipientFromOrgz={props.recipientFromOrgz}
          rgzStatus={props.rgzStatus}
        />
      </div>
    </Modal>
  );
};
